import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0 }
};

export const IntroSection = () => {
  const scroll = () => {
    document.getElementById("problem")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="intro" className="zone-resolution min-h-[80vh] md:min-h-[85vh] flex items-center justify-center relative pt-14">
      <div className="container-narrow text-center">
        <motion.p 
          initial="hidden" 
          animate="visible" 
          variants={fadeUp}
          transition={{ delay: 0.1, duration: 0.3 }}
          className="text-[11px] font-medium text-muted-foreground tracking-wide uppercase mb-3"
        >
          Product Clarity Audit
        </motion.p>

        <motion.h1 
          initial="hidden" 
          animate="visible" 
          variants={fadeUp}
          transition={{ delay: 0.2, duration: 0.3 }}
          className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold text-foreground leading-tight mb-4 text-balance"
        >
          A structured way to reduce confusion and improve usability
        </motion.h1>

        <motion.p 
          initial="hidden" 
          animate="visible" 
          variants={fadeUp}
          transition={{ delay: 0.3, duration: 0.3 }}
          className="text-sm md:text-base text-muted-foreground max-w-md mx-auto mb-2"
        >
          This is not a redesign first. This is about understanding the product before changing it.
        </motion.p>

        <motion.p 
          initial="hidden" 
          animate="visible" 
          variants={fadeUp}
          transition={{ delay: 0.4, duration: 0.3 }}
          className="text-sm text-muted-foreground/70 max-w-sm mx-auto mb-6 italic"
        >
          Most products do not need more features. They need fewer decisions.
        </motion.p>

        <motion.div 
          initial="hidden" 
          animate="visible" 
          variants={fadeUp}
          transition={{ delay: 0.5, duration: 0.3 }}
        >
          <Button variant="clarity" size="lg" onClick={scroll} className="group">
            Start the audit
            <ArrowDown className="ml-2 h-4 w-4 group-hover:translate-y-0.5 transition-transform" />
          </Button>
        </motion.div>
      </div>

      {/* Scroll hint */}
      <motion.button 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
        onClick={scroll}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-muted-foreground/40 hover:text-muted-foreground transition-colors"
        aria-label="Scroll"
      >
        <span className="text-[9px] tracking-wider uppercase">Scroll</span>
        <div className="w-4 h-5 rounded-full border border-current flex items-start justify-center p-0.5">
          <div className="w-0.5 h-1 bg-current rounded-full animate-bounce" />
        </div>
      </motion.button>
    </section>
  );
};

export default IntroSection;
